var React = require('react');

function ModalCloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .secondary-stroke {\n      stroke: #fff;\n      stroke-width: 1.5px;\n    }\n    .no-fill {\n      fill: none;\n    }\n  "),React.createElement("g",{"transform":"translate(-15869 -4443)","key":1},[React.createElement("circle",{"className":"primary-fill","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(924.992 175)","key":0}),React.createElement("line",{"className":"secondary-stroke no-fill","x2":"7.846","y2":"7.846","transform":"translate(929.569 179.577)","key":1}),React.createElement("line",{"className":"secondary-stroke no-fill","y1":"7.846","x2":"7.846","transform":"translate(929.569 179.577)","key":2})])]);
}

ModalCloseIcon.defaultProps = {"viewBox":"-14944.008 -4268 17 17","className":"icon modal-close"};

module.exports = ModalCloseIcon;

ModalCloseIcon.default = ModalCloseIcon;
